(() => {
  const handle = "seibertron-adult-or-youth-s-o-l-a-g-sports-outdoor-water-resistant-full-finger-touchscreen-gloves-2";
  const assetName = "solag-hi2-tactical-long-finger-size-chart-user-20260728-v1.png";
  const alt = "Seibertron S.O.L.A.G-HI 2.0 tactical long finger adult gloves size chart with hand measurement method";
  const width = 1122;
  const height = 1402;

  function chartUrl() {
    const script = document.currentScript || Array.prototype.slice.call(document.scripts).find((node) => {
      return String(node.src || '').indexOf('solag-hi-half-index-sizechart-restore-20260714') !== -1;
    });
    if (script && script.src) {
      try {
        return new URL(assetName + '?v=202607281230', script.src).href;
      } catch (error) {}
    }
    return '/cdn/shop/files/' + assetName + '?v=202607281230';
  }

  function isTargetPage() {
    return location.pathname.indexOf('/products/' + handle) !== -1;
  }

  function apply() {
    if (!isTargetPage()) return;
    document.querySelectorAll('img').forEach((img) => {
      const src = String(img.getAttribute('src') || '');
      const text = String(img.getAttribute('alt') || '');
      const isSizeChart =
        src.indexOf('tactical-half-index-size-chart') !== -1 ||
        src.indexOf('solag-hi-half-index-size-chart-vertical-20260714') !== -1 ||
        /S\.O\.L\.A\.G-HI 2\.0 half index finger gloves size chart/i.test(text);
      if (!isSizeChart) return;
      img.src = chartUrl();
      img.srcset = '';
      img.alt = alt;
      img.width = width;
      img.height = height;
      img.loading = 'lazy';
      img.decoding = 'async';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  setTimeout(apply, 600);
  setTimeout(apply, 1800);
})();